export const DASHBOARD_CARD_VISIBILITY_STORAGE_KEY = "patrimonio360-dashboard-card-visibility";
export const DASHBOARD_CARD_VISIBILITY_EVENT = "patrimonio360-dashboard-card-visibility-change";

export const DASHBOARD_CARD_KEYS = {
  totalWealth: "totalWealth",
  monthlyRevenue: "monthlyRevenue",
  monthlyExpenses: "monthlyExpenses",
  availableBalance: "availableBalance",
  patrimonyEvolutionPercentage: "patrimonyEvolutionPercentage",
  patrimonyEvolution: "patrimonyEvolution",
  monthlyExpensesByCategory: "monthlyExpensesByCategory",
  globalPosition: "globalPosition",
  assetTypeExposure: "assetTypeExposure",
  currentAssetExposure: "currentAssetExposure",
};

export const DASHBOARD_CARD_SETTINGS = [
  {
    key: DASHBOARD_CARD_KEYS.totalWealth,
    label: "Patrimônio total",
    icon: "account_balance_wallet",
  },
  {
    key: DASHBOARD_CARD_KEYS.monthlyRevenue,
    label: "Receita do mês",
    icon: "leaderboard",
  },
  {
    key: DASHBOARD_CARD_KEYS.monthlyExpenses,
    label: "Despesas do mês",
    icon: "store",
  },
  {
    key: DASHBOARD_CARD_KEYS.availableBalance,
    label: "Saldo disponível",
    icon: "account_balance",
  },
  {
    key: DASHBOARD_CARD_KEYS.patrimonyEvolutionPercentage,
    label: "Evolução patrimonial percentual",
    icon: "show_chart",
  },
  {
    key: DASHBOARD_CARD_KEYS.patrimonyEvolution,
    label: "Evolução patrimonial",
    icon: "trending_up",
  },
  {
    key: DASHBOARD_CARD_KEYS.monthlyExpensesByCategory,
    label: "Despesas por categoria",
    icon: "health_and_safety",
  },
  {
    key: DASHBOARD_CARD_KEYS.globalPosition,
    label: "Posição global",
    icon: "pie_chart",
  },
  {
    key: DASHBOARD_CARD_KEYS.assetTypeExposure,
    label: "Exposição por tipo de ativo",
    icon: "layers",
  },
  {
    key: DASHBOARD_CARD_KEYS.currentAssetExposure,
    label: "Exposição atual por ativo",
    icon: "table_chart",
  },
];

const DEFAULT_DASHBOARD_CARD_VISIBILITY = DASHBOARD_CARD_SETTINGS.reduce(
  (visibility, setting) => ({
    ...visibility,
    [setting.key]: true,
  }),
  {}
);

export const normalizeDashboardCardVisibility = (visibility) =>
  DASHBOARD_CARD_SETTINGS.reduce(
    (normalizedVisibility, setting) => ({
      ...normalizedVisibility,
      [setting.key]: visibility?.[setting.key] !== false,
    }),
    {}
  );

export const getStoredDashboardCardVisibility = () => {
  try {
    const storedValue = window.localStorage.getItem(DASHBOARD_CARD_VISIBILITY_STORAGE_KEY);

    if (!storedValue) {
      return DEFAULT_DASHBOARD_CARD_VISIBILITY;
    }

    return normalizeDashboardCardVisibility(JSON.parse(storedValue));
  } catch {
    return DEFAULT_DASHBOARD_CARD_VISIBILITY;
  }
};

export const persistDashboardCardVisibility = (visibility) => {
  const normalizedVisibility = normalizeDashboardCardVisibility(visibility);

  try {
    window.localStorage.setItem(
      DASHBOARD_CARD_VISIBILITY_STORAGE_KEY,
      JSON.stringify(normalizedVisibility)
    );
  } catch {
    // The current session state still works even when browser storage is unavailable.
  }

  try {
    window.dispatchEvent(
      new CustomEvent(DASHBOARD_CARD_VISIBILITY_EVENT, { detail: normalizedVisibility })
    );
  } catch {
    // Ignore event dispatch failures in restricted browser contexts.
  }

  return normalizedVisibility;
};

export const subscribeToDashboardCardVisibility = (onChange) => {
  const handleVisibilityChange = (event) => {
    onChange(normalizeDashboardCardVisibility(event.detail));
  };

  const handleStorageChange = (event) => {
    if (event.key === DASHBOARD_CARD_VISIBILITY_STORAGE_KEY) {
      onChange(getStoredDashboardCardVisibility());
    }
  };

  window.addEventListener(DASHBOARD_CARD_VISIBILITY_EVENT, handleVisibilityChange);
  window.addEventListener("storage", handleStorageChange);

  return () => {
    window.removeEventListener(DASHBOARD_CARD_VISIBILITY_EVENT, handleVisibilityChange);
    window.removeEventListener("storage", handleStorageChange);
  };
};
